import { createAction } from 'redux-act';

import { ISetError, types } from './types';
import { IErrorType } from '../../constants/types';

export const setError = createAction<ISetError>(types.SET_ERROR);
export const clearError = createAction(types.CLEAR_ERROR);
export const setSocketError = createAction<IErrorType>(types.SET_SOCKET_ERROR);
